module.exports = __webpack_public_path__ + "DINNextLTPro-Bold.woff2?aca69b5cfc4f8e6c741a26faaed1627f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Bold.woff2
// module id = 1415
// module chunks = 0